module.exports = __webpack_public_path__ + "assets/media/dinDon.a095f3c1.mp3";